import { Typography } from '@mui/material'
import { get } from 'lodash'
import React, { useState } from 'react'
import Loader from '../../../common/loader/Loader'
import { Query } from '../../../react-apollo/Components'
import RestrictedView from '../../auth/RestrictedView'
import { i18n } from '../../index'
import { getAllChainReminders } from '../reminders/RemindersQueries'
import { ChainReminder } from '../types'
import ChainRemindersForm from './ChainRemindersForm'
import ChainRemindersTable from './ChainRemindersTable'

export default function ChainRemindersPage() {
  const [editedChainReminder, setEditedChainReminder] = useState<ChainReminder | undefined>()
  const getChainReminders = (data) => {
    return get(data, 'getAllChainReminders', [])
  }

  const onChainReminderEdit = (chainReminder: ChainReminder) => {
    setEditedChainReminder(chainReminder)
  }

  const onResetEditedChainReminder = () => {
    setEditedChainReminder(undefined)
  }

  return (
    <div>
      <div>
        <Typography variant='h6'>{i18n.t('admin.chain.tab.chainReminders')}</Typography>
      </div>
      <Query query={getAllChainReminders}>
        {({ loading, error, data }) => (
          <Loader
            {...{
              loading,
              error,
            }}
          >
            <RestrictedView requiredPermission='manage_chain'>
              <ChainRemindersForm
                editedChainReminder={editedChainReminder}
                onResetEditedChainReminder={onResetEditedChainReminder}
              />
            </RestrictedView>
            <ChainRemindersTable chainReminders={getChainReminders(data)} onChainReminderEdit={onChainReminderEdit} />
          </Loader>
        )}
      </Query>
    </div>
  )
}
